<template>
  <section>
    <section class="full-screen-autoheight" :style="{ backgroundImage: 'url(/static/img/intelmarket/banner.jpg)' }">
      <div class="m-w text-center white scroll-animate" style="padding-top: 230px;">
        <p class="font90 m0" data-animate-class="fade-in-up-1">专业的无人零售服务平台</p>
        <p class="lighter font24 mb26" data-animate-class="fade-in-up-2">Professional unmanned retail service platform</p>
        <p class="lighter font30 mb29" data-animate-class="fade-in-up-3">智能硬件终端丨供应链管理丨用户体系管理</p>
      </div>
    </section>
    <section class="full-screen">
      <swiper :options="swiperOption" style="position:absolute;top: 360px;height: 560px;width: 100%;">
        <swiper-slide>
          <SuperMarket />
        </swiper-slide>
        <div class="swiper-btn-prev" slot="button-prev" style="position: absolute;left: 130px;top: 110px;width: 64px;height: 115px;z-index: 1;">
          <img src="/static/img/intelmarket/left_arrow.svg" />
        </div>
        <div class="swiper-btn-next" slot="button-next" style="position: absolute;right: 130px;top: 110px;width: 64px;height: 115px;z-index: 1;">
          <img src="/static/img/intelmarket/right_arrow.svg" />
        </div>
      </swiper>
      <div class="m-w full-content text-center">
        <div class="scroll-animate" style="padding-top: 120px;">
          <h3 class="font60 m0 red" data-animate-class="fade-in-up-1" style="margin-bottom: 30px;">几禾无人超市</h3>
          <div class="font20 c3" data-animate-class="fade-in-up-2">
            <p>几禾云投建于2015年，涵盖了供应链管理、智能硬件终端及用户体系管理的整体解决方案，是专业的无人零售服务平台。</p>
            <p>2017年10月，几禾云已经支撑了果小7便利小站、连锁酒店新便利、银行步入式无人便利店在内���2000多个无人零售终端的日常运营。</p>
          </div>
        </div>
      </div>
    </section>
    <section class="w100 bg-just" :style="{ backgroundImage: 'url(/static/img/intelmarket/purchase_progress.jpg)', height: '650px' }"></section>
    <section class="w100 text-center" style="height: 800px;">
      <div class="m-w font60 bold" style="padding-top: 150px;margin-bottom: 30px;">
        <span>安全</span><!--
                --><span class="red">,</span><!--
                --><span>保障</span>
      </div>
      <div class="c3 font20 normal-lineheight" style="margin-bottom:60px;">
        <p class="m0">扫码开门，通过消费画像做用户鉴别，使用智能算法和硬件结合降低防盗率，</p>
        <p class="m0">24小时监控无人超市，违禁行为智能识别及远程追讨未支付商品</p>
      </div>
      <div class="secure m-w flex-center">
        <div class="flex-col-center" v-for="(item,$index) in secures" :key="$index" style="width: 290px;height: 310px;border:1px solid #333333;">
          <img :src="item.img" style="height: 210px;">
          <div class="flex-col-center text-left w100" style="height: 100px;text-indent: 15px;">
            <span class="font24 c3">{{item.title}}</span>
            <span class="font20 c9">{{item.des}}</span>
          </div>
        </div>
      </div>
    </section>
    <section class="w100 bg-grey" style="height: 800px;">
      <div class="full-content m-w text-center">
        <div style="padding-top:140px;">
          <h5 class="m0 font70 red" style="margin-bottom: 30px;">数据化管理</h5>
          <div class="font20 c6 normal-lineheight" style="margin-bottom: 120px;">
            <p class="m0">利用大数据与人工智能技术，帮助门店搭建自身业务及数据体系，多端触达消费者，凭借成熟的人脸识别技术，</p>
            <p class="m0">为客户提供营销服务，打通线上线下数据，为线下商家提供淘宝一样的线上运营能力。</p>
          </div>
        </div>
        <div class="w100 c3 flex-between text-center">
          <div class="flex-col-around realtime-data-box">
            <RealTimeData />
            <span class="font20">销售数据实时更新</span>
            <span class="font16 lighter">Real time update of sales data</span>
          </div>
          <div class="flex-col-around realtime-data-box">
            <ShelfManage />
            <span class="font20">货架管理</span>
            <span class="font16 lighter">Shelf management</span>
          </div>
          <div class="flex-col-around realtime-data-box">
            <ProductCollect />
            <span class="font20">商品采集</span>
            <span class="font16 lighter">Commodity collection</span>
          </div>
          <div class="flex-col-around realtime-data-box">
            <BackgroundManage />
            <span class="font20">后台管理</span>
            <span class="font16 lighter">Back-stage management</span>
          </div>
        </div>
      </div>
    </section>
    <section class="w100 bg-just" :style="{ backgroundImage: 'url(/static/img/intelmarket/tech.jpg)',height: '600px' }">
      <div class="m-w text-center" style="padding-top: 75px;">
        <h5 class="m0 font60 white" style="margin-bottom: 30px;">技术支持</h5>
        <div class="font20 white lighter" style="margin-bottom: 70px;">
          <p class="m0">汇集目前最前沿的未来零售技术，聚焦人工智能的商业应用。现正式对外开放体验，让你在这里遇见未来。</p>
        </div>
        <div class="flex-between text-left font24 white">
          <div class="tech-box flex-col-between">
            <img src="/static/img/intelmarket/6_1.svg" />
            <span>商品感应识别</span>
          </div>
          <div class="tech-box flex-col-between">
            <img src="/static/img/intelmarket/6_2.svg" />
            <span>智能防盗系统</span>
          </div>
          <div class="tech-box flex-col-between">
            <img src="/static/img/intelmarket/6_3.svg" />
            <span>在线自助结算系统</span>
          </div>
          <div class="tech-box flex-col-between">
            <img src="/static/img/intelmarket/6_4.svg" />
            <span>远程客服</span>
          </div>
        </div>
      </div>
    </section>
    <InnerFooter />
    <Footer />
  </section>
</template>

<script>
  import InnerFooter from '@/components/InnerFooter'
  import RealTimeData from '@/components/svgs/RealTimeData'
  import BackgroundManage from '@/components/svgs/BackgroundManage'
  import ProductCollect from '@/components/svgs/ProductCollect'
  import ShelfManage from '@/components/svgs/ShelfManage'
  import SuperMarket from '@/components/SuperMarket'

  import VueScroll from '@/api/animateDom'

  import justHeight from '@/api/justHeight'

  import Footer from '@/components/Footer'

  export default {
    components: { InnerFooter, RealTimeData,BackgroundManage,ProductCollect,ShelfManage,SuperMarket,Footer },
    data(){
      return {
        secures: [
          { title: '智能防盗', des: '24小时监控防盗', img: '/static/img/intelmarket/intel_guard.jpg' },
          { title: '智能识别', des: '违禁行为识别，发现破坏行为', img: '/static/img/intelmarket/intel_recog.jpg' },
          { title: '智能追讨', des: '未支付商品追讨', img: '/static/img/intelmarket/intel_due_for.jpg' },
          { title: '智能报警', des: '自动报警', img: '/static/img/intelmarket/intel_alarm.jpg' }
        ],
        swiperOption:{
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev'
          }
        }
      }
    },
    mounted(){
      justHeight.justHeight();
    },
    destroyed() {

    },
  }
</script>

<style scoped>
  .w25-list{
    height: 14.81vh;
    min-height: 100px;
    box-sizing: border-box;
    position: relative;
  }

  .w25-list:nth-child(n+2)::before{
    position: absolute;
    top: 21.875%;
    left: -1px;
    content: '';
    background-color:#DFDFDF;
    width: 2px;
    height: 56.25%;
  }

  .secure div:nth-child(2){
    margin: 0 14px;
  }

  .secure div:nth-child(3){
    margin-right: 14px;
  }

  .fade-in-up-1{
    animation: fadeInUp1 .5s ease;
  }

  .fade-in-up-2{
    animation: fadeInUp2 .75s ease;
  }

  .fade-in-up-3{
    animation: fadeInUp3 1s ease;
  }

  @keyframes fadeInUp1 {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, 200%, 0);
      transform: translate3d(0, 200%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInUp2 {
    0%{
      opacity: 0;
      -webkit-transform: translate3d(0, 200%, 0);
      transform: translate3d(0, 200%, 0);
    }

    33.33% {
      opacity: 0;
      -webkit-transform: translate3d(0, 200%, 0);
      transform: translate3d(0, 200%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInUp3 {
    0%{
      opacity: 0;
      -webkit-transform: translate3d(0, 200%, 0);
      transform: translate3d(0, 200%, 0);
    }

    66.66% {
      opacity: 0;
      -webkit-transform: translate3d(0, 200%, 0);
      transform: translate3d(0, 200%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .realtime-data-box{
    height: 200px;
  }

  .realtime-data-box svg{
    width: 155px;
    margin: auto;
  }

  .tech-box{
    width: 232px;
    height: 232px;
    padding: 16px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #ffffff;
    position: relative;
  }

  .tech-box::after{
    content: '+';
    font-size: .45rem;
    position: absolute;
    top: 16px;
    right: 16px;
    color: #ffffff;
    font-weight: lighter;
  }

  .tech-box svg,.tech-box img {
    width: 116px;
    height: 116px;
  }

  .realtime-data-box span{
    margin-bottom: 7px;
  }

  .swiper-container{
    overflow: unset;
  }
</style>



// WEBPACK FOOTER //
// src/pages/IntelMarket/index.vue